import React from 'react';
import { t } from 'src/viewLayer/helpers/translations';
import TrackableLink from 'src/viewLayer/components/shared/TrackableLink';
import { getRegistrationUrl } from 'src/dataLayer/env';
import { useRouteParamsContext } from 'src/viewLayer/components/contexts/RouteParamsContext';
import { useAppConfigContext } from 'src/viewLayer/components/contexts/AppConfigContext';
import './index.scss';

export default () => {
  const { locale } = useRouteParamsContext();
  const { devicePath } = useAppConfigContext();

  if (devicePath !== 'login') return null;

  return (
    <TrackableLink
      className="hint-link"
      data-testid="signup-link"
      href={ getRegistrationUrl(locale) }
      trackingId={'signup_link'}>
        { t('email.links.signup_question') }
        <span>
          { t('email.links.signup_action') }
        </span>
    </TrackableLink>
  );
};
